const mainGreen = {
    /**
     * Preview: ![green 50](#E8FCE8)
     */
    50: '#E8FCE8',
    /**
     * Preview: ![green 100](#D6FAD6)
     */
    100: '#D6FAD6',
    /**
     * Preview: ![green 200](#C4F8C4)
     */
    200: '#C4F8C4',
    /**
     * Preview: ![green 300](#B2F6B2)
     */
    300: '#B2F6B2',
    /**
     * Preview: ![green 400](#A6F4A6)
     */
    400: '#A6F4A6',
    /**
     * Preview: ![green 500](#C6FCA6)
     */
    500: '#C6FCA6',
    /**
     * Preview: ![green 600](#B6F9A6)
     */
    600: '#B6F9A6',
    /**
     * Preview: ![green 700](#A6F69A)
     */
    700: '#A6F69A',
    /**
     * Preview: ![green 800](#96F396)
     */
    800: '#96F396',
    /**
     * Preview: ![green 900](#86F086)
     */
    900: '#86F086',
    /**
     * Preview: ![green A100](#D0FCD0)
     */
    A100: '#D0FCD0',
    /**
     * Preview: ![green A200](#C6FCC6)
     */
    A200: '#C6FCC6',
    /**
     * Preview: ![green A400](#BCFCBC)
     */
    A400: '#BCFCBC',
    /**
     * Preview: ![green A700](#B2FEB2)
     */
    A700: '#B2FEB2',
};

export default mainGreen;
